import {Button, Divider} from '@mui/material'
import {Link, useNavigate, useParams} from 'react-router-dom'
import React, {useEffect} from 'react'
import {useGetSharingByIdQuery} from '../../../rtkGuildApi'
import {useCurrentGuildContext, useDatxPathGenerator} from '../../../../util/routing'
import {ROUTES} from '../../../../constants/routing'
import './SpecificItemSharing.scss'
import {SearchPhraseForm} from '../../../../header/menuComponents/SearchPhraseForm'
import {
    SearchResultTableForSpecificItemSharing
} from '../../../../search/searchResultPage/components/SearchResultTable/SearchResultTableForSpecificItemSharing'
import {useFullSearch} from '../../../../search/searchResultPage/useFullSearch'

const ManageSpecificItemSharing = () => {
    const fullSearchResult = useFullSearch({})
    const {
        fullSearchParams: {managedByGuildId, phrase, phraseTools, applySearchParams}
    } = fullSearchResult
    const generatePath = useDatxPathGenerator()
    const [currentGuildContext] = useCurrentGuildContext()
    const {sharingId} = useParams()
    const {data: sharingDetail, isLoading} = useGetSharingByIdQuery(sharingId!, {skip: !sharingId})

    const navigate = useNavigate()

    useEffect(() => {
        if (
            currentGuildContext?.guildId &&
            currentGuildContext.guildId !== managedByGuildId
        ) {
            navigate(generatePath(ROUTES.itemsSharedToOtherGuilds.path))
        }
    }, [currentGuildContext?.guildId])

    const onSearch = (event: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLElement>, inputText: string) => {
        event.preventDefault()
        phraseTools.setValue(inputText)
        applySearchParams()
    }


    const onReset = () => {
        if (phraseTools.resetValue()) applySearchParams()
    }

    if (isLoading) return <Button />

    return (
        <div className="manage-specific-item-page-container">
            <div className="share-by-title-container">
                <h5 id="shareSpecificItemsTitle" className="page-title">
                    Share Specific Items with <span>{sharingDetail?.targetGuildName}</span>
                </h5>
                <Divider className="divider-title"/>
            </div>

            <div className="management-section">
                <div className="management-header">
                    <div className="search-section">
                        <SearchPhraseForm
                            onSearch={onSearch}
                            inputTestId="specific-items-search-field"
                            placeholder="Search Items by Part Number (minimum 3 characters to search)"
                            searchButtonTestId="specific-items-search-button"
                        />
                        {phrase && (
                            <Button
                                className="reset-button"
                                variant="text"
                                onClick={onReset}
                                data-testid="search-reset"
                            >
                                Reset
                            </Button>
                        )}
                    </div>
                    <Button
                        data-testid="add-items"
                        className="select-item-list-sharing-button"
                        variant="contained"
                        color="primary"
                        size="small"
                        component={Link}
                        to={generatePath(ROUTES.selectItemListForSharing.path, {sharingId: sharingId})}
                        state={{targetGuildName: sharingDetail?.targetGuildName}}
                    >
                        Add
                    </Button>
                </div>
            </div>

            <SearchResultTableForSpecificItemSharing fullSearchResult={fullSearchResult}/>

            <Divider className="divider"/>
            <div className="step-footer">
                <div className="footer-contents">
                    <Button
                        className="back-button"
                        component={Link}
                        to={generatePath(ROUTES.itemsShareToOtherGuild.path, {sharingId: sharingId})}
                    >
                        Back to Manage Sharing
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default ManageSpecificItemSharing